var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SnippetDisplay',{staticClass:"display-rank",attrs:{"rank":_vm.rank,"isFeaturedSnippet":_vm.isFeaturedSnippet}})}
var staticRenderFns = []

export { render, staticRenderFns }